import { useEffect, useState } from 'react'

/**
 * Hook to detect mobile devices based on viewport width
 * Returns true if viewport width is less than 768px (Tailwind's md breakpoint)
 * 
 * Reactive to viewport changes for proper responsive behavior
 */
export function useMobileDevice(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    // Initialize with correct value to prevent hydration mismatch
    if (typeof window === 'undefined') return false
    return window.innerWidth < 768
  })

  useEffect(() => {
    // Return early if window is not available (SSR)
    if (typeof window === 'undefined') return

    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }

    // Set initial value
    checkMobile()

    // Listen for viewport changes
    window.addEventListener('resize', checkMobile)

    return () => {
      window.removeEventListener('resize', checkMobile)
    }
  }, [])

  return isMobile
}

